import type { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	<svg width={props.width || '1em'} height={props.height || '1em'} fill="none" {...props} viewBox="0 0 12 16">
		<path
			stroke={props.color || 'var(--icon)'}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M3.413 14.5h5.174c.464 0 .833-.51.783-1.096C9.048 9.625 7.125 9.688 7.125 8c0-1.688 1.948-1.594 2.245-5.404.047-.587-.319-1.096-.783-1.096H3.413c-.464 0-.83.509-.783 1.096C2.927 6.406 4.875 6.28 4.875 8c0 1.719-1.923 1.625-2.245 5.404-.05.587.319 1.096.783 1.096Z"
		/>
		<path
			fill={props.color || 'var(--icon)'}
			d="M8.046 13.5H3.964c-.366 0-.469-.563-.212-.911.62-.839 1.873-1.44 1.873-2.402V7c0-.62-.89-1.094-1.442-2.1-.09-.166-.081-.4.15-.4h3.345c.197 0 .24.232.15.398C7.285 5.906 6.375 6.377 6.375 7v3.188c0 .954 1.306 1.468 1.884 2.402.234.376.152.91-.213.91Z"
		/>
	</svg>
);
export default SvgComponent;
